import https from "https";
import request from 'request';
import { promiseTimeout } from "../tools";
import { timeoutRequisitionMs } from "../config";
import { getHeaderDefault, removeTokenUserStorage } from "../../actions";

export default class httpHttpsRequest {

    constructor(options) {
        if (options === undefined)
            throw new Error("Sem opção Na requisição");



        let newOptions = {};
        Object.assign(newOptions, options);

        this.options = newOptions;
        this.data = [];

        if (!this.options.showLoading) {
            this.options.showLoading = () => { };
        }

        if (!this.options.hideLoading) {
            this.options.hideLoading = () => { };
        }

        if (!options.headers) {
            this.options.headers = getHeaderDefault();
        }
    }

    setHeader(header) {
        this.options.headers = header;
    }

    setOptions(options) {
        let newOptions = {};
        Object.assign(newOptions, options);

        this.options = newOptions;
    }

    addRequestBody(body) {

        this.data = body;
    }

    addQueryString(params) {
        let concat = '?';
        let result = '';
        for (let param in params) {
            if (params.hasOwnProperty(param)) {
                result += concat + `${param}=${params[param]}`;
                concat = '&';
            }
        }
        if (this.options == null || this.options.path == null) {
            throw new Error('Erro nas opções')
        } else {
            this.options.path += result;
        }
    }

    makeRequest() {
        this.options.showLoading();
        return promiseTimeout(timeoutRequisitionMs, this._makeRequest(), this.options.hideLoading);
    }

    _makeRequest() {
        if (this.options.protocolRequest === 'HTTPS') {
            //this._addHttpsToPath();
            return this.makeHttpsRequest();
        }
        else {
            this._addHttpToPath();
            let options = this._getHttpOptions();
            return this.makeHttpRequest(options);
        }
    }

    _addHttpsToPath() {
        this.options.host = `https://${this.options.host}`;
    }

    _addHttpToPath() {
        this.options.host = `http://${this.options.host}`;
    }

    _getHttpOptions() {
        let options = {
            url: this.options.host + this.options.path,
            method: this.options.method,
            headers: this.options.headers,
            showLoading: this.options.showLoading,
            hideLoading: this.options.hideLoading
        };

        options.body = JSON.stringify(this.data);

        return options;
    }


    makeHttpRequest(options) {
        return new Promise((resolve, reject) => {
            try {
                request(options, function (err, response, body) {
                    options.hideLoading();
                    if (err) {
                        return reject(response);
                    }
                    if (response.statusCode === 401 || response.statusCode === 403) {
                        removeTokenUserStorage();
                        return reject(response);
                    }
                    if (response.statusCode < 200 || response.statusCode >= 300) {
                        return reject(response);
                    }
                    resolve(body);
                });
            } catch (err) {
                options.hideLoading();
                console.log(err);
            }
        });
    }

    makeHttpsRequest() {
        let options = this.options;
        return new Promise((resolve, reject) => {
            let request = https.request(options, function (response) {

                response.setEncoding('utf8');

                if (response.statusCode === 401) {
                    removeTokenUserStorage();
                    return reject(response);
                }

                if (response.statusCode < 200 || response.statusCode >= 300) {
                    return reject(response);
                }

                let resData = '';

                response.on('data', function (chunk) {
                    resData += chunk;
                });

                response.on('end', function () {
                    options.hideLoading();
                    return resolve(resData);
                });

            });

            request.on('error', function (err) {
                options.hideLoading();
                return reject(err);
            });

            request.write(JSON.stringify(this.data));
            request.end();
        }).catch((err) => {
            this.options.hideLoading();
            console.log(err)
        });
    }
}



// WEBPACK FOOTER //
// ./src/util/http-request/request.js